import dayjs from 'dayjs'
import { Stack, Theme, Typography } from '@mui/material'
import { TBlend } from 'types'

const mainTitle = {
  fontSize: '20px',
  fontWeight: '700',
}

const subTitle = {
  fontSize: '14px',
  fontWeight: '400',
  color: (theme: Theme) => theme.palette.custom.black,
}

export const SavedBlendDetailsHeaderInfo = ({ blend }: { blend?: TBlend }) => (
  <Stack flex={1}>
    <Typography sx={mainTitle}>{blend?.name || ''}</Typography>
    {blend?.created_by_name && (
      <Typography sx={subTitle}>
        Created by: {blend.created_by_name || ''} @{' '}
        {dayjs(blend?.creation_date).format('DD.MM.YY | HH:mmA')}
      </Typography>
    )}
  </Stack>
)
